import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useAddClassificationReview({
  onSuccess,
}: {
  onSuccess?: ({ category }: { category: string | null | undefined }) => void
} = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.addDocumentClassificationReviewDocumentsKeyClassificationReviewsPostMutation(),
    onSuccess: (_, variables) => {
      onSuccess?.({ category: variables.body.document_category })
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
    },
  })
}
